import moment from 'moment';

function getEstimatedFee(startTime, eventProfessionId, isAmex) {
  if (isAmex) {
    return 21.0;
  } else {
    return 17.5;
  }
}

export { getEstimatedFee };
